import { UserModel } from 'api/model';
import CopyableUserDetails from './CopyableUserDetails';
import Roles, { includesRoles } from 'constants/Roles';

const FieldTesterBadge: React.FC<{ user: UserModel; roles: number[] }> = ({
  user,
  roles,
}) => {
  const showNumber = includesRoles([Roles.Admin], roles);

  return (
    <span style={{ whiteSpace: 'nowrap' }}>
      {user?.name}{' '}
      {showNumber && (
        <CopyableUserDetails
          name={user?.name}
          number={user?.phoneNumber ?? ''}
        />
      )}
    </span>
  );
};

export default FieldTesterBadge;
